import React from "react";
import "../../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import { typeMap } from "../../constants";
import { downloadReport, setPageNoUploadReport } from "../../action";
import { useDispatch, useSelector } from "react-redux";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
import ReactPaginate from "react-paginate";
import moment from "moment";

const Table = (props) => {
  const dispatch = useDispatch();
  const { uploadReportTableData ,totalPagesUploadReport} = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  const downloadFile = (row, type) => {
    const reportType = typeMap[type];
    if (reportType) {
      dispatch(downloadReport(row, reportType));
    } else {
      console.error("Invalid type provided");
    }
  };
  const createClickableCell = (value, row, type) => {
  const hasValidRecords = value && 
                         value !== "0" && 
                         value !== "" && 
                         value !== null && 
                         value !== undefined;
  
  return (
    <div
      style={{
        width: "100%",
        color: hasValidRecords ? "blue" : "black",
        cursor: hasValidRecords ? "pointer" : "auto",
      }}
      onClick={hasValidRecords ? () => downloadFile(row, type) : null}
    >
      {hasValidRecords ? value : '--'}
    </div>
  );
};
// Add this function above your columns array
function uploadStatusFormatter(cell, row) {
  const status = row?.UPLOAD_STATUS?.toUpperCase();
  let color = "#000";
  if (status === "FAILED") color = "red";
  else if (status === "COMPLETED") color = "green";

  return (
    <div
      style={{
        cursor: status === "FAILED" ? "pointer" : "auto",
        width: "100%",
        textAlign: "center",
        color,
      }}
    >
      {status === "COMPLETED" || status === "FAILED" ? row.UPLOAD_STATUS : "In-progress"}
    </div>
  );
}

  const columns = [
    {
      dataField: "REPORT_NAME",
      text: "Report Name",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "17%",
      },
      formatter: (cell, row) => (
        <>
          {row.REPORT_NAME ? row.REPORT_NAME : '--'}
        </>
      ),
    },
    {
      dataField: "TOTAL_RECORDS",
      text: "Total",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "17%",
      },
      // formatter: (cell, row) => {
      //   return (
      //     <div
      //       style={{
      //         width: "100%",
      //         color: row.TOTAL_RECORDS !== "0" ? "blue" : "black",
      //         cursor: row.TOTAL_RECORDS !== "0" ? "pointer" : "auto",
      //       }}
      //       onClick={row.TOTAL_RECORDS != "0" ? () => downloadFile(row, "total") : null}
      //     >
      //       {row.TOTAL_RECORDS ? row.TOTAL_RECORDS : '--'}
      //     </div>
      //   );
      // },
      formatter: (cell, row) => createClickableCell(row.TOTAL_RECORDS, row, "total"),

    },
    {
      dataField: "PASSED_RECORDS",
      text: "Passed",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "17%",
      },
      // formatter: (cell, row) => {
      //   return (
      //     <div
      //       style={{
      //         width: "100%",
      //         color: row.PASSED_RECORDS !== "0" ? "blue" : "black",
      //         cursor: row.PASSED_RECORDS !== "0" ? "pointer" : "auto",
      //       }}
      //       onClick={row.PASSED_RECORDS != "0" ? () => downloadFile(row, "pass") : null}
      //     >
      //       {row.PASSED_RECORDS ? row.PASSED_RECORDS : '--'}
      //     </div>
      //   );
      // },
      formatter: (cell, row) => createClickableCell(row.PASSED_RECORDS, row, "pass"),

    },

    {
      dataField: "FAILED_RECORDS",
      text: "Failed",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "17%",
      },
      // formatter: (cell, row) => {
      //   return (
      //     <div
      //       style={{
      //         width: "100%",
      //         color: row.FAILED_RECORDS !== "0" ? "blue" : "black",
      //         cursor: row.FAILED_RECORDS !== "0" ? "pointer" : "auto",
      //       }}
      //       onClick={row.FAILED_RECORDS != "0" ? () => downloadFile(row, "fail") : null}
      //     >
      //       {row.FAILED_RECORDS ? row.FAILED_RECORDS : '--'}
      //     </div>
      //   );
      // },
      formatter: (cell, row) => createClickableCell(row.FAILED_RECORDS, row, "fail"),
    },
    {
      dataField: "UPLOAD_STATUS",
      text: "Upload Status",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "17%",
      },
      // formatter: (cell, row) => displayNullFormatter(row, "UPLOAD_STATUS"),
       formatter:(cell, row) => uploadStatusFormatter(cell,row),
    },
    {
      dataField: "CREATED_DATE",
      text: "Timestamp",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "15%",
      },
      formatter: (cell, row) => <>
      {row.CREATED_DATE ? moment(row.CREATED_DATE).format("DD-MM-YYYY HH:mm:ss") : "--"}
      </>,
    },
  ];

  return (
    <>
      {uploadReportTableData?.length > 0 ? (
        <div
          className="light-border-gstr2a2bnew-table"
          style={{
            marginTop: "0.6em",
            height: "25em",
          }}
        >
          <BootstrapTable
            keyField="gstin"
            data={uploadReportTableData}
            columns={columns}
            rowStyle={rowStyle2}
          />
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
             pageCount={totalPagesUploadReport}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
        </div>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
